/* tslint:disable */
/* eslint-disable */
/**
 * Bioplan API
 * Backend API for Bioplan, an aquaculture production planning tool.
 *
 * Contact: support@optimeeringaqua.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type {Configuration} from '../configuration';
import type {AxiosPromise, AxiosInstance, RawAxiosRequestConfig} from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from '../common';
// @ts-ignore
import {BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap} from '../base';
// @ts-ignore
import type {Site} from '../bioplanModels';
// @ts-ignore
import type {WriteSite} from '../bioplanModels';
/**
 * PlanningSiteApi - axios parameter creator
 * @export
 */
export const PlanningSiteApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Get all sites, filtered by plan ID
     * @param {string} planId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sitesGet: async (planId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'planId' is not null or undefined
      assertParamExists('sitesGet', 'planId', planId);
      const localVarPath = `/sites/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (planId !== undefined) {
        localVarQueryParameter['planId'] = planId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Create site
     * @param {WriteSite} writeSite
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sitesPost: async (writeSite: WriteSite, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'writeSite' is not null or undefined
      assertParamExists('sitesPost', 'writeSite', writeSite);
      const localVarPath = `/sites/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'POST', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(writeSite, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Delete site by its identifier
     * @param {string} siteId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sitesSiteIdDelete: async (siteId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'siteId' is not null or undefined
      assertParamExists('sitesSiteIdDelete', 'siteId', siteId);
      const localVarPath = `/sites/{siteId}`.replace(`{${'siteId'}}`, encodeURIComponent(String(siteId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'DELETE', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get site by its identifier. Include children.
     * @param {string} siteId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sitesSiteIdGet: async (siteId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'siteId' is not null or undefined
      assertParamExists('sitesSiteIdGet', 'siteId', siteId);
      const localVarPath = `/sites/{siteId}`.replace(`{${'siteId'}}`, encodeURIComponent(String(siteId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Update site
     * @param {string} siteId
     * @param {WriteSite} writeSite
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sitesSiteIdPut: async (
      siteId: string,
      writeSite: WriteSite,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'siteId' is not null or undefined
      assertParamExists('sitesSiteIdPut', 'siteId', siteId);
      // verify required parameter 'writeSite' is not null or undefined
      assertParamExists('sitesSiteIdPut', 'writeSite', writeSite);
      const localVarPath = `/sites/{siteId}`.replace(`{${'siteId'}}`, encodeURIComponent(String(siteId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'PUT', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(writeSite, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get site by its identifier
     * @param {string} siteId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sitesSiteIdSimpleGet: async (siteId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'siteId' is not null or undefined
      assertParamExists('sitesSiteIdSimpleGet', 'siteId', siteId);
      const localVarPath = `/sites/{siteId}/simple`.replace(`{${'siteId'}}`, encodeURIComponent(String(siteId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * PlanningSiteApi - functional programming interface
 * @export
 */
export const PlanningSiteApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = PlanningSiteApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Get all sites, filtered by plan ID
     * @param {string} planId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async sitesGet(
      planId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Site>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.sitesGet(planId, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningSiteApi.sitesGet']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Create site
     * @param {WriteSite} writeSite
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async sitesPost(
      writeSite: WriteSite,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Site>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.sitesPost(writeSite, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningSiteApi.sitesPost']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Delete site by its identifier
     * @param {string} siteId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async sitesSiteIdDelete(
      siteId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.sitesSiteIdDelete(siteId, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningSiteApi.sitesSiteIdDelete']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get site by its identifier. Include children.
     * @param {string} siteId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async sitesSiteIdGet(
      siteId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Site>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.sitesSiteIdGet(siteId, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningSiteApi.sitesSiteIdGet']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Update site
     * @param {string} siteId
     * @param {WriteSite} writeSite
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async sitesSiteIdPut(
      siteId: string,
      writeSite: WriteSite,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Site>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.sitesSiteIdPut(siteId, writeSite, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningSiteApi.sitesSiteIdPut']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get site by its identifier
     * @param {string} siteId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async sitesSiteIdSimpleGet(
      siteId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Site>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.sitesSiteIdSimpleGet(siteId, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningSiteApi.sitesSiteIdSimpleGet']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * PlanningSiteApi - factory interface
 * @export
 */
export const PlanningSiteApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = PlanningSiteApiFp(configuration);
  return {
    /**
     *
     * @summary Get all sites, filtered by plan ID
     * @param {PlanningSiteApiSitesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sitesGet(
      requestParameters: PlanningSiteApiSitesGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<Site>> {
      return localVarFp.sitesGet(requestParameters.planId, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Create site
     * @param {PlanningSiteApiSitesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sitesPost(requestParameters: PlanningSiteApiSitesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<Site> {
      return localVarFp.sitesPost(requestParameters.writeSite, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Delete site by its identifier
     * @param {PlanningSiteApiSitesSiteIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sitesSiteIdDelete(
      requestParameters: PlanningSiteApiSitesSiteIdDeleteRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .sitesSiteIdDelete(requestParameters.siteId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get site by its identifier. Include children.
     * @param {PlanningSiteApiSitesSiteIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sitesSiteIdGet(
      requestParameters: PlanningSiteApiSitesSiteIdGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Site> {
      return localVarFp.sitesSiteIdGet(requestParameters.siteId, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Update site
     * @param {PlanningSiteApiSitesSiteIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sitesSiteIdPut(
      requestParameters: PlanningSiteApiSitesSiteIdPutRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Site> {
      return localVarFp
        .sitesSiteIdPut(requestParameters.siteId, requestParameters.writeSite, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get site by its identifier
     * @param {PlanningSiteApiSitesSiteIdSimpleGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sitesSiteIdSimpleGet(
      requestParameters: PlanningSiteApiSitesSiteIdSimpleGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Site> {
      return localVarFp
        .sitesSiteIdSimpleGet(requestParameters.siteId, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * Request parameters for sitesGet operation in PlanningSiteApi.
 * @export
 * @interface PlanningSiteApiSitesGetRequest
 */
export interface PlanningSiteApiSitesGetRequest {
  /**
   *
   * @type {string}
   * @memberof PlanningSiteApiSitesGet
   */
  readonly planId: string;
}

/**
 * Request parameters for sitesPost operation in PlanningSiteApi.
 * @export
 * @interface PlanningSiteApiSitesPostRequest
 */
export interface PlanningSiteApiSitesPostRequest {
  /**
   *
   * @type {WriteSite}
   * @memberof PlanningSiteApiSitesPost
   */
  readonly writeSite: WriteSite;
}

/**
 * Request parameters for sitesSiteIdDelete operation in PlanningSiteApi.
 * @export
 * @interface PlanningSiteApiSitesSiteIdDeleteRequest
 */
export interface PlanningSiteApiSitesSiteIdDeleteRequest {
  /**
   *
   * @type {string}
   * @memberof PlanningSiteApiSitesSiteIdDelete
   */
  readonly siteId: string;
}

/**
 * Request parameters for sitesSiteIdGet operation in PlanningSiteApi.
 * @export
 * @interface PlanningSiteApiSitesSiteIdGetRequest
 */
export interface PlanningSiteApiSitesSiteIdGetRequest {
  /**
   *
   * @type {string}
   * @memberof PlanningSiteApiSitesSiteIdGet
   */
  readonly siteId: string;
}

/**
 * Request parameters for sitesSiteIdPut operation in PlanningSiteApi.
 * @export
 * @interface PlanningSiteApiSitesSiteIdPutRequest
 */
export interface PlanningSiteApiSitesSiteIdPutRequest {
  /**
   *
   * @type {string}
   * @memberof PlanningSiteApiSitesSiteIdPut
   */
  readonly siteId: string;

  /**
   *
   * @type {WriteSite}
   * @memberof PlanningSiteApiSitesSiteIdPut
   */
  readonly writeSite: WriteSite;
}

/**
 * Request parameters for sitesSiteIdSimpleGet operation in PlanningSiteApi.
 * @export
 * @interface PlanningSiteApiSitesSiteIdSimpleGetRequest
 */
export interface PlanningSiteApiSitesSiteIdSimpleGetRequest {
  /**
   *
   * @type {string}
   * @memberof PlanningSiteApiSitesSiteIdSimpleGet
   */
  readonly siteId: string;
}

/**
 * PlanningSiteApi - object-oriented interface
 * @export
 * @class PlanningSiteApi
 * @extends {BaseAPI}
 */
export class PlanningSiteApi extends BaseAPI {
  /**
   *
   * @summary Get all sites, filtered by plan ID
   * @param {PlanningSiteApiSitesGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningSiteApi
   */
  public sitesGet(requestParameters: PlanningSiteApiSitesGetRequest, options?: RawAxiosRequestConfig) {
    return PlanningSiteApiFp(this.configuration)
      .sitesGet(requestParameters.planId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Create site
   * @param {PlanningSiteApiSitesPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningSiteApi
   */
  public sitesPost(requestParameters: PlanningSiteApiSitesPostRequest, options?: RawAxiosRequestConfig) {
    return PlanningSiteApiFp(this.configuration)
      .sitesPost(requestParameters.writeSite, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Delete site by its identifier
   * @param {PlanningSiteApiSitesSiteIdDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningSiteApi
   */
  public sitesSiteIdDelete(
    requestParameters: PlanningSiteApiSitesSiteIdDeleteRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PlanningSiteApiFp(this.configuration)
      .sitesSiteIdDelete(requestParameters.siteId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get site by its identifier. Include children.
   * @param {PlanningSiteApiSitesSiteIdGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningSiteApi
   */
  public sitesSiteIdGet(requestParameters: PlanningSiteApiSitesSiteIdGetRequest, options?: RawAxiosRequestConfig) {
    return PlanningSiteApiFp(this.configuration)
      .sitesSiteIdGet(requestParameters.siteId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Update site
   * @param {PlanningSiteApiSitesSiteIdPutRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningSiteApi
   */
  public sitesSiteIdPut(requestParameters: PlanningSiteApiSitesSiteIdPutRequest, options?: RawAxiosRequestConfig) {
    return PlanningSiteApiFp(this.configuration)
      .sitesSiteIdPut(requestParameters.siteId, requestParameters.writeSite, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get site by its identifier
   * @param {PlanningSiteApiSitesSiteIdSimpleGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningSiteApi
   */
  public sitesSiteIdSimpleGet(
    requestParameters: PlanningSiteApiSitesSiteIdSimpleGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PlanningSiteApiFp(this.configuration)
      .sitesSiteIdSimpleGet(requestParameters.siteId, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
